const state = () => ({
  discussions: {},
});

const getters = {
  enabled: (state, getters, rootState, rootGetters) => {
    const productVar = rootGetters['productVars/get']['discussion_enabled'];
    if (productVar) {
      return [true, 'true'].includes(productVar.value);
    }
  },
  getDiscussionsByFlashcardId: (state, getters, rootState, rootGetters) => (flashcardId) => {
    const resourceKey = 'V3Flashcard_' + flashcardId;
    return state.discussions[resourceKey];
  },
};

const mutations = {
  setDiscussions(state, data) {
    state.discussions = {};
    data.forEach(discussion => {
      const resourceKey = discussion.resourceType + '_' + discussion.resourceId;
      if (!state.discussions[resourceKey]) {
        state.discussions[resourceKey] = [];
      }
      state.discussions[resourceKey].push(discussion);
    });
  },
};

const actions = {
  createDiscussion({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/discussions', params).then(response => {
      return response.data.discussion;
    });
  },
  deleteDiscussion({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].delete(`/discussions/${params.id}`);
  },
  fetchDiscussions({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/discussions', { params }).then(response => {
      commit('setDiscussions', response.data.discussions);
      return response.data.discussions;
    });
  },
  followDiscussion({ dispatch, commit, getters, rootGetters }, params) {
    params = {
      assetable_type: 'Discussion',
      assetable_id: params.id,
      notification_type: 'discussion_reply',
    };
    return rootGetters['session/ajax'].post('/user_notification_subscriptions', params).then(response => {
      return response.data.discussions;
    });
  },
  unfollowDiscussion({ dispatch, commit, getters, rootGetters }, params) {
    params = {
      assetable_type: 'Discussion',
      assetable_id: params.id,
      notification_type: 'discussion_reply',
      _method: 'delete',
    };
    /*
     * _delete to allow sending of parrams and the delete
     * method to be called on the rails side
     */
    return rootGetters['session/ajax'].post('/user_notification_subscriptions', params).then(response => {
      return response.data.discussions;
    });
  },
  updateDiscussion({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].put(`/discussions/${params.id}`, params).then(response => {
      return response.data.discussion;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
